import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private lang: string;

  public setLang(lang: string) {
    this.lang = lang;
  }

  public getLang(): string {
    return this.lang;
  }

}
